module.exports = __webpack_public_path__ + "static/gem-364f8f3a5d1a67543473cbee7aa76c91.png";